import { Component, Input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-store-auto-remove-popover",
  standalone: true,
  imports: [TranslateModule, MatButtonModule, MatIconModule],
  templateUrl: "./store-auto-remove-popover.component.html",
  styleUrl: "./store-auto-remove-popover.component.scss",
})
export class StoreAutoRemovePopoverComponent {
  @Input() closePopover?: () => void;
  @Input() onLearnMore?: () => void;

  openKnowledgeBase(): void {
    this.onLearnMore?.();
  }
}
